
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 61.23 75.51"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#b6bbff","d":"M13.67 50.76l17.67-13.21 17.3 12.84 1.31 21.58-37.96.19 1.68-21.4z"}}),_c('path',{attrs:{"d":"M45.92 21.94l-15.3 11-15.31-11V6.12h30.61zm.21 30.92v16.53H15.51V52.86l15.11-11.12zm5.92-46.74h9.17V0H0v6.12h9.22V25l17 12.35L9.39 49.69v19.7H0v6.12h61.22v-6.12h-9v-19.7L35 37.35 52 25z","fill":"#7e7e7e"}})])
          )
        }
      }
    